export default class LeaderBoard {
  constructor() {
    this.init();
  }

  init() {
    // this.initEvents();
    this.apiLink = 'none'
    // console.log('init', this.apiLink)
  }

  //On load when user arrive to game
  // getCookie(dd_user) to get email, initials, and score and rank
  // Dont need it on the
  getTimeForUser(){
    var cookied = this.getCookie('dd_time');
    if(cookied){
      // console.log('returning c');
      return cookied;
    }else{
      // console.log('creating c');

      let d = Date.now();
      this.setCookie('dd_time',d,37500);
      return d;
    }
  }

  isNewUser(callback) {

    var cookied = this.getCookie("dd_user");
    if (cookied) {
      var ca = cookied.split(",");
      callback(false,ca[0], ca[0], ca[2],ca[3])
      // document.getElementById('welcome').innerHTML = "Welcome returning user "+ca[0] + " your best score so far is "+ca[2];
    } else {
      callback(true)
      //  document.getElementById('welcome').innerHTML = "Welcome totally new fresh user!";
    }
  }

  getLeaderboard(callback){
    // var xhr = new XMLHttpRequest();
    // var url = this.apiLink+"/leaderboard";
    // xhr.open("GET", url, true);
    // xhr.setRequestHeader("Content-Type", "application/json");
    // xhr.onreadystatechange = function() {
    //     if (xhr.readyState == XMLHttpRequest.DONE && xhr.status === 200) {
    //         const result  = JSON.parse(xhr.responseText);
    //         callback(result.entries);
    //     }
    // }
    // xhr.send();
  }

  // getCookie(game_session) store sesion as JWT. get start time as date compare with Date.now() format UTC = initial remain time.
  startGame() {
    var _this = this;
    //var xhr = new XMLHttpRequest();
    var url = this.apiLink+"/init";
    //xhr.open("GET", url, true);
    //xhr.setRequestHeader("Content-Type", "application/json");

    //if this cookie is set, then we already have a game going on
    //we still have to send the request beacuse this token might have been expired on the server
    //if so the server will start a new game session
    var cookied = this.getCookie("game_session");
    if (cookied) {
      // xhr.setRequestHeader("Authorization", "Bearer " + cookied);
    }else{
      //POS CAMPAIGN
      _this.setCookie("game_session", "{999:999}", 65); //token is JWT, 65 = expiration time.
    }

    
    // xhr.onreadystatechange = function () {
    //   if (xhr.readyState === 4 && xhr.status === 200) {
    //     //response from API GAME STARTED
    //     //document.getElementById("start_response").innerHTML = xhr.responseText;
    //     let userObj = JSON.parse(xhr.responseText);
    //     console.log('get token',userObj)
    //     _this.setCookie("game_session", userObj.access_token, 65); //token is JWT, 65 = expiration time.
    //   } else if (xhr.readyState === 4 && xhr.status === 400) {
    //     //response from API GAME ALREADY STARTED
    //     //document.getElementById("start_response").innerHTML = xhr.responseText;
    //   } else if (xhr.readyState === 4 && xhr.status === 403) {
    //     // document.getElementById("start_response").innerHTML = xhr.responseText;
    //   }
    // };
    // xhr.send();
  }

  stopGame(u_initials,u_email,u_score,u_verifier,callbackAccepted,callbackRejected) {
    // var xhr = new XMLHttpRequest();
    // var url = this.apiLink+"/register";
    // var _this = this;
    // xhr.open("POST", url, true);
    // xhr.setRequestHeader("Content-Type", "application/json");
    // var cookied = this.getCookie("game_session");
    // xhr.setRequestHeader("Authorization", "Bearer " + cookied);
    // xhr.onreadystatechange = function () {
    //   if (xhr.readyState === 4 && xhr.status === 200) {
    //     //response from API GAME ENDED

    //     //erase the game session cookie
    //     // _this.eraseCookie("game_session");

    //     //set the user cookie
    //     const result = JSON.parse(xhr.responseText);
    //     _this.setCookie(
    //       "dd_user",
    //       result.alias + "," + result.email + "," + result.score + "," + result.position,
    //       28800
    //     );
    //     callbackAccepted(result.position,result.alias,result.score);

    //   } else if (xhr.readyState === 4 && xhr.status === 400) {
    //     //response from API GAME NO GAME WAS STARTED
    //     //erase the game session cookie
    //     // _this.eraseCookie("game_session");
    //     console.log("end_response",xhr.responseText);
    //     // document.getElementById("end_response").innerHTML =
    //     //   document.getElementById("end_response").innerHTML +
    //     //   "  " +
    //     //   xhr.responseText;
    //   } else if (xhr.readyState === 4 && xhr.status === 401) {
    //     //erase the game session cookie
    //     // _this.eraseCookie("game_session");
    //     console.log("end_response",xhr.responseText);
    //     callbackRejected()
    //     // // document.getElementById("end_response").innerHTML = xhr.responseText;
    //   } else if (xhr.readyState === 4 && xhr.status === 500) {
    //     //erase the game session cookie
    //     // _this.eraseCookie("game_session");
    //     console.log("end_response",xhr.responseText);
    //     // document.getElementById("end_response").innerHTML = xhr.responseText;
    //   }
    // };
    // //{"score":100,"email" : "test2@cymo.eu","alias" : "TDD"}
    // var data = JSON.stringify({
    //   score: u_score,
    //   email: u_email,
    //   alias: u_initials,
    //   verifier: u_verifier
    // });

    // xhr.send(data);
    // console.log("score submitted to backend: " + u_score + " backend did not respond are initials and email filled in?")
  }

  generateRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  setCookie(name, value, minutes) {
    var expires = "";
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  eraseCookie(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
}
